import { getInventoryRows } from '../Inventory/helpers/strictSearches.helper';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { AppSiteMarketplaceType, InventoryOperation } from '../AppAndSiteMarketplace.types';

/** Number of rows the list of a tab shows for an operation (same row builders as the lists). */
export function getTabOperationCount(
  appSiteConfiguration: TargetingBaseType['appSiteConfiguration'] | undefined,
  type: AppSiteMarketplaceType,
  operation: InventoryOperation
): number {
  return getInventoryRows(appSiteConfiguration, type, operation).length;
}

/** Number of items (included + excluded rows) of a tab. */
export function getTabItemsCount(
  appSiteConfiguration: TargetingBaseType['appSiteConfiguration'] | undefined,
  type: AppSiteMarketplaceType
): number {
  return (
    getTabOperationCount(appSiteConfiguration, type, 'include') +
    getTabOperationCount(appSiteConfiguration, type, 'exclude')
  );
}
